import { ShieldCheck, Users, HeartPulse } from "lucide-react";

export default function About() {
  return (
    <div className="mx-auto max-w-4xl px-4 py-14 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">About Doctor+</h1>
      <p className="mt-4 text-lg leading-relaxed text-slate-700">
        Doctor+ (www.doctor-plus.in) is India's trusted doctor discovery and appointment booking platform. We help patients find verified doctors, compare consultation fees, and book clinic or online appointments in just a few clicks.
      </p>
      <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
        {[
          { i: ShieldCheck, t: "Verified", d: "Every doctor is approved by our admin team after medical registration verification." },
          { i: Users, t: "Trusted by millions", d: "Over 1M bookings across 50+ Indian cities and 15,000+ verified specialists." },
          { i: HeartPulse, t: "Patient-first", d: "Pay at clinic or online, book for family members, read real reviews." },
        ].map((v) => (
          <div key={v.t} className="card p-6">
            <v.i className="h-6 w-6 text-teal-600" />
            <div className="mt-3 text-lg font-bold text-slate-900">{v.t}</div>
            <p className="mt-1 text-sm text-slate-600">{v.d}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
